<div class="page-padding">
  <h1 class="bottom-sheet-title">{{'add-new-card.Secure' | translate}}</h1>
  <form [formGroup]="addNewCardForm" (ngSubmit)="onSubmit()">
    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding">
        <h1 class="card-detail-text">{{'add-new-card.Card' | translate}}</h1>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-icon name="camera"></ion-icon>
        <h1 class="scan-card-text link-text-blue" (click)="showScanError()">{{'add-new-card.Scan' | translate}}</h1>
      </ion-col>
    </ion-row>
    <input class="card-number" type="text" placeholder="Enter card number" [formControlName]="'cardNumber'" />
    <ion-row>
      <h1 class="card-detail-text">{{'add-new-card.Cardholder' | translate}}</h1>
      <input class="card-holder-name" type="text" placeholder="Enter cardholder name"
        [formControlName]="'holderName'" />
    </ion-row>
    <ion-row class="ion-no-padding cvc-expiry-date-wrapper">
      <ion-col class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <h1 class="card-detail-text date-and-cvv">{{'add-new-card.Expiry' | translate}}</h1>
          <input type="text" placeholder="MM/YY" class="expiry-date" [formControlName]="'expiryDate'" />
        </ion-row>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <h1 class="card-detail-text date-and-cvv">{{'add-new-card.Verification' | translate}}</h1>
          <input type="text" placeholder="CVC" [formControlName]="'cvcCode'" />
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-row class="billing-wrapper">
      <ion-col class="ion-no-padding">
        <h1 class="total-txt">{{'add-new-card.Payble' | translate}}</h1>
      </ion-col>
      <ion-col class="ion-no-padding">
        <h1 class="total-amount">£10.50/wk</h1>
      </ion-col>
    </ion-row>
    <ion-button size="small" expand="block" class="action-btn-large" type="submit">{{'add-new-card.Pay' | translate}}
    </ion-button>
  </form>
  <h1 class="back-text link-text-blue" (click)="closeBottomSheet()">&larr; {{'add-new-card.Back' | translate}}</h1>
</div>